.grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section {
  overflow: hidden;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-card);
  background: var(--panel);
}

/* The tinted bar that names a section. */
.bar {
  margin: 0;
  padding: 7px 12px;
  border-bottom: 1px solid var(--line-2);
  background: var(--panel-3);
  color: var(--ink);
  font-size: var(--t-dense);
  font-weight: 650;
}

.cells {
  margin: 0;
}

/* Four columns: label, value, label, value. A wide value spans the three after its label. */
.row {
  display: grid;
  grid-template-columns: minmax(110px, 0.7fr) minmax(0, 1.3fr) minmax(110px, 0.7fr) minmax(0, 1.3fr);
}

.row + .row {
  border-top: 1px solid var(--line-2);
}

.label,
.value,
.blank {
  min-width: 0;
  margin: 0;
  padding: 8px 12px;
  border-left: 1px solid var(--line-2);
}

.row > :first-child {
  border-left: 0;
}

/* The shaded label cell. */
.label {
  background: var(--panel-2);
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.value {
  color: var(--ink);
  font-size: var(--t-body);
  font-variant-numeric: lining-nums tabular-nums;
  overflow-wrap: anywhere;
}

.wide {
  grid-column: span 3;
}

.mono {
  font-family: var(--mono);
  font-size: var(--t-dense);
}

.blank {
  background: var(--panel-2);
}

@media (max-width: 760px) {
  .row {
    grid-template-columns: minmax(110px, 0.7fr) minmax(0, 1.3fr);
  }

  .row > :nth-child(n + 3) {
    border-top: 1px solid var(--line-2);
  }

  .row > :nth-child(odd) {
    border-left: 0;
  }

  .wide {
    grid-column: auto;
  }

  .blank {
    display: none;
  }
}
